var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1262_5303)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 8.8174 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12ZM16.656 16.1736C17.4648 16.6272 18.1968 17.1936 18.8352 17.8536C17.9912 18.8412 16.9431 19.634 15.763 20.1772C14.583 20.7204 13.2991 21.0011 12 21C9.264 21 6.816 19.7808 5.1648 17.856C6.62557 16.3452 8.54558 15.3607 10.6249 15.0564C12.7043 14.752 14.8235 15.1449 16.656 16.1736ZM12 12.5544C12.4728 12.5544 12.9409 12.4613 13.3777 12.2804C13.8144 12.0995 14.2113 11.8343 14.5456 11.5C14.8799 11.1657 15.1451 10.7688 15.326 10.3321C15.5069 9.89529 15.6 9.42716 15.6 8.9544C15.6 8.48164 15.5069 8.01351 15.326 7.57674C15.1451 7.13997 14.8799 6.74311 14.5456 6.40882C14.2113 6.07452 13.8144 5.80935 13.3777 5.62843C12.9409 5.44752 12.4728 5.3544 12 5.3544C11.0452 5.3544 10.1295 5.73369 9.45442 6.40882C8.77929 7.08395 8.4 7.99962 8.4 8.9544C8.4 9.90918 8.77929 10.8249 9.45442 11.5C10.1295 12.1751 11.0452 12.5544 12 12.5544Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1262_5303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.bdd993ea69d7851306609db3a208f083.svg";
export { ForwardRef as ReactComponent };